import { LOGIN, LOGOUT, LOCK, UNLOCK, REFRESH_TOKENS } from "./authActionTypes";
import { IAuthResponse } from "../../models/Authentication/Authentication.models";

const login = (user: IAuthResponse) => ({
  type: LOGIN,
  payload: user,
});

const logout = () => ({
  type: LOGOUT,
});

const lock = () => ({
  type: LOCK,
});

const unlock = (user: IAuthResponse) => ({
  type: UNLOCK,
  payload: user,
});

const refreshTokens = (user: IAuthResponse) => ({
  type: REFRESH_TOKENS,
  payload: user,
});

export { login, logout, lock, unlock, refreshTokens };
